import React, { useEffect, useState } from "react";
import { Card, Col } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import ChartComponent from "../Highcharts/ChartComponent";
import { genderPieConfig } from "../Highcharts/chartconfig";
import axios from "axios";
import Loader from "./Loader";

function HumanRightes({ requestData }) {
  const [chartCounter, setChartCounter] = useState(null);

  useEffect(() => {
    let requestBody = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      distributionOnCasesIdentifier: [
        "Gender based violence",
        "Discrimination/Stigmatization",
        "Sexual reproductive health rights",
        "Neglect",
      ],
      languageId: 1,
      serviceId: 458,
    };
    if (Object.keys(requestData).length > 0) {
      let oRequest = { ...requestBody, ...requestData };
      if (
        (requestData?.globalFilters?.dateFilter.to !== "" &&
          requestData?.globalFilters?.dateFilter.from !== "") ||
        (requestData.questionIds != null &&
          requestData.selectedOption != null) ||
        (requestData.subQuestionIds != null &&
          requestData.selectedOption != null) ||
        requestData.serviceIdFilter != null
      ) {
        getHumanRightsData(oRequest);
      }
    } else {
      getHumanRightsData(requestBody);
    }
  }, [requestData]);

  let getHumanRightsData = async (data) => {
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/distributionOfHumanRights `,
        data
      );
      let formatedData = res.data.data;
      let sortedArray = Object.entries(formatedData).sort(([keyA], [keyB]) =>
        keyA.localeCompare(keyB)
      );

      let sortedFormatedData = Object.fromEntries(sortedArray);
      let humRightsArr = [];
      let colorArr = ["#7030A0", "#2E75B6", "#C30D0D", "#203864"];
      Object.keys(sortedFormatedData).forEach((key, index) => {
        let percentVal = {};
        if (
          sortedFormatedData[key] !== 0 &&
          totalValue(sortedFormatedData) !== 0
        ) {
          percentVal["percent"] = Math.round(
            (sortedFormatedData[key] / totalValue(sortedFormatedData)) * 100
          );
          percentVal["number"] = sortedFormatedData[key];
        } else {
          percentVal["percent"] = 0;
          percentVal["number"] = 0;
        }
        let obj = {
          name: key,
          count: percentVal,
          color: colorArr[index],
        };
        humRightsArr = [...humRightsArr, obj];
      });

      setChartCounter(humRightsArr);
    } catch (error) {
      console.log(error);
    }
  };
  const totalValue = (data) => {
    let values = Object.values(data);
    const sumWithIndictors = values.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    return sumWithIndictors;
  };

  return (
    <Card>
      {/* <Card.Header>Resolved</Card.Header> */}
      <Card.Body className="pb-0">
        <Row>
          {chartCounter && chartCounter.length > 0 ? (
            chartCounter.map((eleObj, index) => {
              return (
                <Col lg={3}>
                  <h5>{eleObj?.name}</h5>
                  <ChartComponent
                    key={index}
                    options={genderPieConfig(eleObj)}
                  />
                </Col>
              );
            })
          ) : (
            <Loader />
          )}
        </Row>
      </Card.Body>
    </Card>
  );
}

export default HumanRightes;
